import { buildProfileSchema } from '../lib/googleSchema';
import { IMGIX_STYLE_4, imgixImageUrl, PROFILE_IMAGE_DIMS } from '../lib/imgix';

export function getBaseHelmet(profile, location, intl) {
  return {
    ogImage: imgixImageUrl({
      path: `/artists/${profile.id}/main.jpg`,
      style: IMGIX_STYLE_4,
      width: PROFILE_IMAGE_DIMS.w,
      height: PROFILE_IMAGE_DIMS.h,
    }),
    ogType: 'profile',
    googleSchema: buildProfileSchema({ ...profile, pathname: location.pathname }, intl),
  };
}
